module.exports = __webpack_public_path__ + "img/sfinx.584c1d53.jpg";